import { storyblokEditable } from '@storyblok/react/rsc'

const VideoSource = ({ blok }) => {
  const fileExtension = blok?.video?.filename?.split('.')?.pop()

  return (
    <source
      {...storyblokEditable}
      key={blok?.video?.filename}
      src={blok?.video?.filename}
      type={
        fileExtension === 'mov'
          ? 'video/quicktime; codecs=hvc1'
          : fileExtension === 'webm'
            ? 'video/webm; codecs=vp9'
            : `video/${fileExtension}`
      }
    />
  )
}

export default VideoSource
